var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26592 0.688017C9.26785 0.688017 11.2704 0.696137 13.2723 0.682395C13.7608 0.679272 14.02 1.00658 13.9988 1.40509C13.98 1.75613 13.9907 2.10904 13.9963 2.46133C13.9994 2.66371 13.9326 2.83174 13.7983 2.98165C12.797 4.1041 11.7976 5.2278 10.7982 6.35151C10.2666 6.94865 9.73632 7.54767 9.20164 8.14231C9.12981 8.22227 9.0992 8.30159 9.09983 8.41028C9.10358 9.8744 9.09858 11.3379 9.10483 12.802C9.10607 13.0944 9.00301 13.308 8.7669 13.4822C7.99361 14.0519 7.22907 14.6328 6.45953 15.2081C6.17408 15.4211 5.86426 15.4217 5.6319 15.2137C5.47387 15.0725 5.42577 14.8895 5.42577 14.684C5.42702 12.9332 5.4264 11.183 5.4264 9.43217C5.4264 9.08987 5.43264 8.74758 5.42203 8.40591C5.41953 8.32033 5.38455 8.21727 5.32896 8.15418C3.81486 6.44458 2.29764 4.73747 0.776052 3.03536C0.608027 2.84798 0.521829 2.64997 0.530574 2.39637C0.542442 2.0497 0.532447 1.70241 0.533697 1.35512C0.534946 0.936618 0.781049 0.688641 1.19955 0.688641C3.22147 0.688017 5.24338 0.688017 7.26592 0.688017Z",
    fill: "#6E6BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d1c7a39222dd90aa4b72da5ecea25845.svg";
export { ForwardRef as ReactComponent };